import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import initApp from 'utils/functions/init';
import { Contexts } from 'constants/context';
// eslint-disable-next-line max-len
import ScansPriceListsContainer from 'modules/categories/scans/container/ScansPriceListsContainer';
import { useParams } from 'react-router-dom';
import { fetchSelectedealthPlan } from 'modules/healthPlans/healthPlansSlice';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const ScansPriceListsPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const { healthPlanId } = useParams();

  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    initApp(Contexts.Scans);
    dispatch(fetchSelectedealthPlan(healthPlanId));
  }, [dispatch]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <ScansPriceListsContainer />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

ScansPriceListsPage.propTypes = {};

ScansPriceListsPage.defaultProps = {};

export default ScansPriceListsPage;
